import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useSession } from "@/hooks/use-session";

/**
 * Reads the singleton AthleteProfile for the currently signed-in user.
 *
 * Returns:
 *  - data: the profile row, or null if not yet created (drives /onboarding redirect)
 *  - isLoading: true while the query is in-flight
 *
 * Cache key includes the auth user id so a sign-out clears the cache cleanly.
 */
export function useAthleteProfile() {
  const { session, loading: sessionLoading } = useSession();
  const userId = session?.user?.id;

  return useQuery({
    queryKey: ["athlete_profile", userId],
    enabled: !sessionLoading && Boolean(userId),
    queryFn: async () => {
      if (!userId) return null;
      const { data, error } = await supabase
        .from("athlete_profile")
        .select("*")
        .eq("user_id", userId)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
  });
}
